module.exports = require("jquery");


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 4
// module chunks = 0